// var base_url = 'https://rc.bjxqwl.cn';
// if (process.env.NODE_ENV === "development") base_url = 'https://rc.bjxqwl.cn';
// var base_url = 'https://tcb.bjxqwl.cn';
var base_url = 'https://lianjiehoutai.xhcl.pro';
// if (process.env.NODE_ENV === "development") base_url = 'https://tcb.bjxqwl.cn';
// if (process.env.NODE_ENV === "development") base_url = 'https://cd.bjxqwl.cn';
// if (process.env.NODE_ENV === "development") base_url = 'https://cd1.bjxqwl.cn';
if (process.env.NODE_ENV === "development") base_url = 'https://lianjiehoutai.xhcl.pro';
// cd是另外一个项目
module.exports = {
    // 请求接口地址 如果没有配置自动获取当前网址路径
    apiBaseURL: base_url,
    //最长请求时间
    requestTimeout: 12000,
    // 配置护短数据的接收方式application/json;charset=UTF-8或者applicattion/x-www-form-urlencoded;charset=UTF-8
    contentType:'application/json;charset=UTF-8',
    //操作正常code，支持String、Array、int多种类型
    successCode: [200, 201],
}